import React from 'react'
import { useTranslation } from 'react-i18next'
import BannerImg from '../../../assets/images/Andorra Company Formation-banner.png'
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import SEO from "../../../utils/SEO";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import IntroSection from "../../../components/IntroSection/IntroSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";

function CompanyFormationAndorra() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.company-formation-andorra.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });
    const withIcon = (k, icon) => (obj(k) || []).map((it) => ({ ...it, icon }));

    return (
        <main className='main'>

            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/company-formation-andorra"
            />

                <section className='section'>
                <IntroSection
                    title={tp('intro.title')}
                    description={tp('intro.description')}
                    imageSrc={require('../../../assets/images/Andorra Company Formation-hero.png')}
                    buttonText={tp('intro.button')}
                    buttonLink="/quote"
                    imageAlt={tp('intro.imageAlt')}
                />

                <div className='container'>
                    <InfoBlocks
                        title={tp('whyChoose.title')}
                        blocks={[{ items: withIcon('whyChoose.items', TiTick) }]}
                    />

                    <br/><br/>

                    <h1 className='page-title'>{tp('servicesHeading')}</h1>
                    <p className='page-paragraph'>{tp('servicesIntro')}</p>

                    <strong>{tp('servicesLead')}</strong>

                    <h2 className='page-subtitle'>{tp('step1.heading')}</h2>
                    <p>{tp('step1.p')}</p>
                    <WhySection title={tp('step1.whyTitle')} blocks={[{ items: withIcon('step1.items', GoDotFill) }]} />
                    <BannerPageImg src={BannerImg}/>

                    <h2 className='page-title'>{tp('step2.heading')}</h2>
                    <p className='page-paragraph'>{tp('step2.p')}</p>
                    <WhySection title={tp('step2.whyTitle')} blocks={[{ items: withIcon('step2.items', GoDotFill) }]} />

                    <h2 className='page-title'>{tp('step3.heading')}</h2>
                    <p>{tp('step3.p')}</p>
                    <WhySection title={tp('step3.whyTitle')} blocks={[{ items: withIcon('step3.items', GoDotFill) }]} />

                    <h2 className='page-title'>{tp('step4.heading')}</h2>
                    <WhySection title={tp('step4.whyTitle')} blocks={[{ items: withIcon('step4.items', GoDotFill) }]} />

                    <h2 className='page-title'>{tp('step5.heading')}</h2>
                    <h3 className='page-paragraph'>{tp('step5.lead')}</h3>
                    <WhySection title={tp('step5.lead')} blocks={[{ items: obj('step5.items') }]} />

                    <DetailsSection
                        title={tp('approach.title')}
                        subtitle={tp('approach.subtitle')}
                        items={obj('approach.items')}
                    />

                    <div className='flex-start'>
                        <WhySection
                            title={tp('types.title')}
                            blocks={[{ items: obj('types.items') }]}
                        />

                        <WhySection
                            title={tp('benefit.title')}
                            subtitle={tp('benefit.subtitle')}
                            blocks={[{ items: obj('benefit.items') }]}
                            end={tp('benefit.end')}
                        />
                    </div>

                    <Testimonials title={tp('testimonials.title')} testimonials={obj('testimonials.items')}/>

                    <FAQList title={tp('faq.title')} data={obj('faq.items')} />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/consultation"
                    />

                </div>
            </section>
        </main>
    )
}

export default CompanyFormationAndorra
